// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "ical_calendar".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "ical_calendar" table (1:1 with a DB row, on the wire). */
export const icalCalendarAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    userId: z.string(),
    tokenHash: z.string(),
    encryptedToken: z.string(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=icalCalendar.js.map